import React from "react";


import {MuiIconExternalProps} from "../../../components/icons/MuiIcon";

import {FacebookIcon} from "../../../components/icons/social/FacebookIcon";
import {InstagramIcon} from "../../../components/icons/social/InstagramIcon";
import {TelegramIcon} from "../../../components/icons/social/TelegramIcon";
import {RedditIcon} from "../../../components/icons/social/RedditIcon";
import {TwitterIcon} from "../../../components/icons/social/TwitterIcon";


export const AuthSocialRow = () => (
    <div className={'Auth-social-links'}>
        <ExternalLink Icon={FacebookIcon} link={'https://www.facebook.com/logycore'}/>
        <ExternalLink Icon={InstagramIcon} link={'https://www.instagram.com/logycore_team/'}/>
        <ExternalLink Icon={TelegramIcon} link={'https://t.me/logycore'}/>
        <ExternalLink Icon={RedditIcon} link={'https://www.reddit.com/r/Logycore/'}/>
        <ExternalLink Icon={TwitterIcon} link={'https://twitter.com/logycore_team'}/>
    </div>
)

interface ExternalLinkProps {
    Icon: React.ComponentType<MuiIconExternalProps>;
    link: string;
}

const ExternalLink = ({Icon, link}: ExternalLinkProps) => (
    <Icon size={24} onClick={() => {
        /* @ts-ignore */
        window.open(link, '_blank').focus();
    }}/>
)